export const SharedStoreFeatureKey = `shared-store`;